export default __webpack_public_path__ + "60cb5e432dc05e628ac46dd10735fd29.woff2";